var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.homePage)?_c('Home'):_c('App')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }